export default {"src":"/_next/static/media/carDetailNextImgArrow.3eccffb2.svg","height":46,"width":32};